import { render, staticRenderFns } from "./supercOrderDetails.vue?vue&type=template&id=2cdb0332&"
import script from "./supercOrderDetails.vue?vue&type=script&lang=js&"
export * from "./supercOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./supercOrderDetails.vue?vue&type=style&index=0&id=2cdb0332&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports